import { Container,Group, createStyles, Paper, Text, Title, Alert, Button} from '@mantine/core';

import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect} from 'react';

//import { ShowUserForMeeting } from './helper/ShowUserForMeeting';
import intl from 'react-intl-universal';

dayjs.extend(duration);

interface GuestMeetingData {
    datStart: string; // Assuming datStart is a string, change the type if it's different
}

const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  contback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  sysback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "70vw",
    position: "relative",
  },

  guestfooter: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
    backgroundColor: "#efefef",
    borderTop: `1px solid #ddd`,
    paddingLeft: `20px`,
    paddingRight: `20px`,
  },
  footerheadline: {
    fontWeight: 200,
    fontSize: "1.2em",
    color: "#00445E"
  },
  inside: {
    listStyleType: "none",
    paddingLeft: 0,
    margin: "0 0 20px;"
  },
  inside_li: {
    fontWeight: 400,
    fontSize: "89%",
    color: "#00445E",
  },
  paper: { 
    width: "60vw",
  },
  padtop10: {
    paddingTop: `10px`,
  },
}));


const GuestLeftMeeting = (props:any) => {
    const dispatch = useDispatch()
    const { classes } = useStyles();
    const guestmeetingdata = useSelector((state: any) => state.user.guest_meetinginfo)
    const guest_isValid = useSelector((state: any) => state.user.guest_isValid)
    const guestme = useSelector((state: any) => state.user.guest_meinfo)
    const guest_joinlink = useSelector((state: any) => state.user.guest_joinlink)
    const guest_leftmeeting = useSelector((state: any) => state.user.guest_leftmeeting)
    const guest_notarleftmeeting = useSelector((state: any) => state.user.guest_notarleftmeeting)
    const guest_have_removed = useSelector((state: any) => state.user.guest_has_removed)

    //console.log(guestme)
    console.log("guest_have_removed: " + guest_have_removed)
    
    // -- End Test Only --

    useEffect(() => {
     // console.log(guestmeetingdata.id)
      // Request the initial meeting data
      const reqmeetingdatapayload = {
        MeetingParticipantId: guestme.id,
      };
      if (guestmeetingdata.id === undefined) {
        dispatch({ type: 'GUEST_SIGNALR_GETMEETINGDATA', payload: reqmeetingdatapayload });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    

  
  return (
 
    <Container fluid className={classes.contback}> 
         {guest_leftmeeting && guest_joinlink.length === 0 && guest_have_removed === false &&
          <Paper shadow="sm" p="xl" className={classes.paper}>
          <Title order={2} align={"center"}>{intl.get('GUESTLEFT_HEAD')}</Title>
          <hr />
                <Alert  title={intl.get('GUESTLEFT_HEAD_1')} color="green">
                {intl.get('GUESTLEFT_THX_INFO')}
                 </Alert>
                <hr />
                <Text>{intl.get('GUESTLEFT_THX_INFO_1')}</Text>
               
                
          </Paper>
          }

       {guest_leftmeeting && guest_joinlink.length === 0 && guest_have_removed === true &&
          <Paper shadow="sm" p="xl" className={classes.paper}>
          <Title order={2} align={"center"}>{intl.get('GUESTLEFT_HEAD')}</Title>
          <hr />
                <Alert  title={intl.get('GUEST_NOTAR_KICKED_USER')} color="red">
                {intl.get('GUEST_NOTAR_KICKED_USER_TEXT')}
                 </Alert>
                <hr />
                <Text>{intl.get('GUESTLEFT_THX_INFO_1')}</Text>
               
                
          </Paper>
          }

       {guest_notarleftmeeting && guest_joinlink.length !== 0 && guest_have_removed === false &&
          <Paper shadow="sm" p="xl" className={classes.paper}>
          <Title order={2} align={"center"}>{intl.get('GUEST_NOTAR_LEFT_HEAD')}</Title>
          <hr />
                <Alert  title={intl.get('GUEST_NOTAR_LEFT_HEAD_1')}>
                  {intl.get('GUEST_NOTAR_LEFT_INFO_1')}
                 </Alert>
                <hr />
                <Text>{intl.get('GUEST_NOTAR_LEFT_INFO_2')} </Text>
               
          </Paper>
          }


      </ Container>    
  
    );
  }
  
  export default GuestLeftMeeting;